var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mission-asset-map"},[_c('mapbox',{ref:"mapbox",attrs:{"height":_vm.mapHeight},on:{"map-loaded":_vm.onMapLoaded,"map-styledata":_vm.onMapStyleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }